import { Box, RadioButtonGroup, Text } from 'grommet';
import { StyledTooltip } from '../../../../../components/common/StyledTooltip';
import React from 'react';
import { t } from 'i18next';
import { FormInputProps } from '../FieldItem';

export const PaymentOptionInput: React.FC<FormInputProps> = ({ field, saveField, options, country }) => {
  const isAnnual = field.properties?.paymentOption === 'ANNUAL';

  const handleChange = (event: any) => {
    saveField({ ...field, properties: { ...field.properties, paymentOption: event.target.value } });
  };

  return (
    <>
      {country !== 'br' && (
        <Box gap={'4px'}>
          <Text style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', color: '#282828', textAlign: 'start' }}>
            {t('fieldFlow.fieldItem.paymentOption.title')}
          </Text>

          <StyledTooltip label={t('fieldFlow.fieldItem.paymentOption.annualTooltip')} showToolTip={isAnnual}>
            <Box width={'fit-content'}>
              <RadioButtonGroup
                direction={'row'}
                data-cy={`field-paymentOption-${field.properties?.['name']}`}
                disabled={isAnnual}
                name={'paymentOption'}
                id={'paymentOption' + field.id}
                value={field.properties?.['paymentOption']}
                onChange={handleChange}
                options={options}
              />
            </Box>
          </StyledTooltip>
        </Box>
      )}
    </>
  );
};
